export enum InvoiceEnum {
    WITH_IMAGES = 'with_image',
    WITHOUT_IMAGES = 'without_image'
}
